<template>
  <div class="brainscharts">
    <div class="chartselectorcontainer">
      <chartselector />
    </div>
    <div v-if="positionenabled" class="components-container">
      <div class="visualization-container">
        <div v-if="loading" class="brains-map-loader dataSidebarLoader" />
        <div class="chartviewersectionsidebar">
          <div ref="maincontainerdiv" v-loading="loading">
            <div v-if="ningunChart && !loading" class="container-alert-no-data">
              <el-alert :title="$t('chartsData.data-not-available-for-this-lvl')" type="warning" show-icon :closable="false" />
            </div>
            <div class="row">
              <div
                v-for="chart in sectioncharts"
                :key="chart.name"
                class="responsive-chart-1366 highchart-global-styles highchart--resize"
                :class="'col-' + columnSizeView"
              >
                <div v-if="checkchartdata(chart)" class="chartdataok">
                  <highcharts
                    v-if="chart.type !=='stocktable'"
                    :options="chart.options"
                  />
                  <stocktable
                    v-else
                    :options="chart.options"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="position-not-selected">
      {{ $t('position-not-selected') }}
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import chartselector from '@/components/BrainsChartSelector'
import stocktable from '@/components/StockTableChart'
import { Chart } from 'highcharts-vue'
import { generateHigchartOptions, generateStackTableOptions } from '@/utils/chartutils'
import solidgauge from 'highcharts/modules/solid-gauge'
import patternfill from 'highcharts/modules/pattern-fill'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import stockInit from 'highcharts/modules/stock'
import loadExporting from 'highcharts/modules/exporting'
import loadExportingData from 'highcharts/modules/export-data'
import i18n from '@/i18n'

Highcharts.setOptions({
  lang: {
    decimalPoint: ',',
    thousandsSep: '.',
    printChart: i18n.t('print-chart'),
    viewFullscreen: i18n.t('view-full-screen'),
    downloadPNG: i18n.t('download-png-image'),
    downloadJPEG: i18n.t('download-jpeg-image'),
    downloadPDF: i18n.t('download-pdf-document'),
    downloadSVG: i18n.t('download-svg-image'),
    downloadCSV: i18n.t('download-csv'),
    downloadXLS: i18n.t('download-xls')
  },
  exporting: {
    menuItemDefinitions: {
      downloadPNG: {
        onclick: function() {
          this.exportChart({ type: 'image/png' })
        }
      },
      downloadJPEG: {
        onclick: function() {
          this.exportChart({ type: 'image/jpeg' })
        }
      },
      downloadPDF: {
        onclick: function() {
          this.exportChart({ type: 'application/pdf' })
        }
      },
      downloadSVG: {
        onclick: function() {
          this.exportChart({ type: 'image/svg+xml' })
        }
      },
      downloadCSV: {
        onclick: function() {
          this.downloadCSV()
        }
      },
      downloadXLS: {
        onclick: function() {
          this.downloadXLS(false)
        }
      },
      printChart: {
        onclick: function() {
          this.print()
        }
      }
    },

    chartOptions: {
      title: {
        style: {
          fontSize: '14px'
        }
      },
      chart: {
        events: {
          load: function() {
            this.renderer.image('https://www.brainsre.com/static/img/BrainsRE_logonuevo_.f91a45e3.png',
              485, // x
              5, // y
              120, // width
              29 // height
            ).add()
          }
        }
      }
    },
    buttons: {
      contextButton: {
        menuItems: [
          'printChart',
          'viewFullscreen',
          'separator',
          'downloadPNG',
          'downloadJPEG',
          'downloadPDF',
          'downloadSVG',
          'separator',
          'downloadCSV',
          'downloadXLS',
          'openInCloud'
        ]
      }
    }
  },
  chart: {
    spacingLeft: 30,
    spacingRight: 30
  }
})
stockInit(Highcharts)
HighchartsMore(Highcharts)
loadExporting(Highcharts)
loadExportingData(Highcharts)
solidgauge(Highcharts)
patternfill(Highcharts)
export default {
  name: 'BrainsChart',
  components: { chartselector, highcharts: Chart, stocktable },
  data() {
    return {
      loading: false,
      ningunChart: false,
      columnSizeView: 12,
      sectioncharts: []
    }
  },
  computed: {
    ...mapState('location', {
      position: (state) => state.position,
      geolevels: (state) => state.geolevels,
      geolevelselected: (state) => state.geolevelselected
    }),
    ...mapState('charts', {
      selectedchart: (state) => state.selectedchart,
      chartsection: (state) => state.chartsection
    }),
    positionenabled: function() {
      return this.position.latitude !== null
    }
  },
  watch: {
    chartsection: function() {
      this.loadsectioncharts()
    }
  },
  methods: {
    checkchartdata(chart) {
      if (chart.type === 'stocktable') return true
      const alldata = [].concat.apply([], chart.options.series.map(item => { return item.data }))
      // debugger
      return alldata.length > 0
    },
    loadsectioncharts() {
      const vm = this
      if (!this.selectedchart.chart_name) {
        return
      }
      this.loading = true
      const countryname = vm.geolevels[0].name
      /*
      this.$children.filter(item => { return item.$options._componentTag === 'highcharts' }).forEach(item => {
        item.$destroy()
      })
      */
      this.sectioncharts = []
      setTimeout(function() {
        vm.sectioncharts = vm.chartsection.chartsdata.map(item => {
          return {
            name: item.charttitle,
            type: item.charttype,
            options: item.charttype !== 'stocktable' ? generateHigchartOptions(item, vm.chartsection.allseries, vm.geolevelselected.name, countryname, vm.geolevelselected) : generateStackTableOptions(item, vm.chartsection.allseries)
          }
        })
        vm.ningunChart = vm.sectioncharts.length === 0
        vm.loading = false
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.chartviewersectionsidebar {
  margin-top: 44px;
  min-width: initial;
  transition: all 0.7s;
  overflow: auto;
  // FIX 1 - CHANGE
  height: calc(100vh - 234px);

  // FIX 1 - CHANGE
  & > div {
    height: 100% !important;
  }

  // FIX 1 - CHANGE
  .el-col-12 {
    width: 100%;
  }
}

/* @media (max-width: 1650px) {
  ::-webkit-scrollbar {
    width: 18px !important;
  }
}

@media (max-width: 1350px) {
  ::-webkit-scrollbar {
    width: 25px !important;
  }
} */

.brains-tabs-details--tab .components-container .visualization-container {
  .chartviewersectionsidebar {
    div:first-child {
      // height: calc(100vh - 270px);
      background-color: white;
    }
  }
}
</style>
